module.exports = __webpack_public_path__ + "media/components/src/assets/images/decor/left_decor-bbd2f2ef5e67063ff315d8806756ba27.svg";